import { Button } from '@coingate/ui/dist/components/Button';
import { GetAccountsURL, Request } from '@javascript/helpers';

const StepNavigation = ({
  isFirstStep,
  onBack
}: {
  isFirstStep: boolean
  onBack: () => void
}) => {
  const signOut = () => {
    Request('/users/sign_out', 'DELETE')
  }

  return (
    <>
      {isFirstStep ? (
        <div className="text-base text-white">
          <span className="font-normal">Already have an account?</span>{' '}
          <a
            className="font-semibold text-white no-underline! hover:text-white hover:underline!"
            data-test="log-in-link"
            href={GetAccountsURL('/login')}
            onClick={signOut}
          >
            Log in
          </a>
        </div>
      ) : (
        <Button
          data-testid="go-back"
          className="w-full text-base font-semibold text-grey-300 hover:underline!"
          size="lg"
          variant="unstyled"
          onClick={onBack}
        >
          <span className='flex flex-row gap-0.5'>
            <img src="/chevron-left.svg" />
            Back
          </span>
        </Button>
      )}
    </>
  )
}

export default StepNavigation
